import { Theme } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

type StylesType = {
  numColumns: number
}

const useStyles = makeStyles<Theme, StylesType>(theme => ({
  header: {
    display: 'grid',
    gridTemplateColumns: ({ numColumns }) => `repeat(${numColumns}, 1fr)`,
    gridRowGap: '2rem',
    gridColumnGap: '2rem',
    borderBottom: '1px solid #F1F1F1',
    borderRadius: '1rem 1rem 0 0',
    padding: '2rem',
    background: 'white',

    [theme.breakpoints.down('md')]: {
      borderRadius: '0'
    },

    [theme.breakpoints.down('lg')]: {
      gridRowGap: '2rem',
      minHeight: 'auto',
      height: 'auto'
    }
  },

  body: {
    flexBasis: '25%',
    display: 'flex',
    justifyContent: 'space-around',
    flexWrap: 'wrap',
    borderRadius: '0 0 1rem 1rem',
    padding: '1rem',
    background: '#F7F8F9',

    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-around',
      flexWrap: 'nowrap',
      minHeight: 'auto',
      padding: '1rem 0 0 0',

      '& > :not(:last-child)': {
        marginBottom: '1rem'
      }
    }
  }
}))

export default useStyles
